class Faq {
  constructor(dom) {
    this.NAME = 'Faq';
    this.dom = dom;
  }

  init() {
    this.dom.querySelectorAll('[data-faq-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => this.toggle(toggle));
    });
  }

  toggle(toggle) {
    const item = toggle.closest('.faq__item');
    if (!item) return;

    const isOpen = item.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
}

export default Faq;
